import { inject, InjectionToken } from '@angular/core';

import { createSelector, StoreConfig } from '@ngrx/store';

import {
  createSingleEntityStore,
  memoizeSelector,
  pipeState,
  SingleEntityState,
} from '@recruitee/ngrx';

import { EntityStoreKey, DEV_FLAGS, DevFlag, DevFlagsMap } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<DevFlagsMap>()(
  EntityStoreKey.DevFlags,
  {
    customActions: adapter => ({
      init: (state, payload: DevFlagsMap) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
    }),
  },
);

const DevFlagSelectors = {
  ...selectors,
  isEnabled: memoizeSelector((devFlag: DevFlag) =>
    createSelector(selectors.data, (devFlagsMap: DevFlagsMap) => devFlagsMap[devFlag]),
  ),
};

export const DevFlagConfigToken = new InjectionToken('DevFlagConfigToken', {
  providedIn: 'root',
  factory: (): StoreConfig<SingleEntityState<DevFlagsMap>> => ({
    initialState: {
      loaded: true,
      failed: false,
      pending: false,
      error: false,
      data: inject(DEV_FLAGS),
    },
  }),
});

export {
  actions as DevFlagActions,
  reducer as DevFlagReducer,
  namespace as DevFlagNamespace,
  DevFlagSelectors,
};
